import _extends from '../../../node_modules/@babel/runtime/helpers/extends.js';
import _defineProperty from '../../../node_modules/@babel/runtime/helpers/defineProperty.js';
import _objectWithoutProperties from '../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js';
import 'prop-types';
import { jsx } from '@emotion/core';
import progressBarStyleObject from '../../styles/progressBar.js';
import { useThemeContext } from '../ThemeProvider/ThemeContext.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var ProgressLinear = function ProgressLinear(_ref) {
  var determinate = _ref.determinate,
      value = _ref.value,
      label = _ref.label,
      theme = _ref.theme,
      otherProps = _objectWithoutProperties(_ref, ["determinate", "value", "label", "theme"]);

  var themeTokens = useThemeContext();

  var progressTrackStyleObject = _objectSpread(_objectSpread(_objectSpread({}, progressBarStyleObject.progressBar__progressTrack), !determinate ? _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, progressBarStyleObject.animBarDeterminate), progressBarStyleObject.progressBar_progressIndeterminate__progressTrack), progressBarStyleObject.keyframesBarIndeterminate), progressBarStyleObject.keyframesBarIndeterminateShort) : {
    width: "".concat(value, "%")
  }), {}, {
    backgroundColor: themeTokens.primaryColor || progressBarStyleObject.progressBar__progressTrack.backgroundColor
  });

  return jsx("div", _extends({
    role: "progressbar",
    "aria-label": label,
    "aria-valuemin": "0",
    "aria-valuemax": "100"
  }, determinate ? {
    'aria-valuenow': value
  } : {}, {
    css: _objectSpread(_objectSpread({}, progressBarStyleObject.progressBar), theme)
  }, otherProps), jsx("div", {
    css: progressTrackStyleObject
  }));
};

ProgressLinear.defaultProps = {
  determinate: false,
  value: 0,
  label: 'Progress Bar',
  theme: undefined
};

export default ProgressLinear;
